interface GetConsentCheckboxTitleArgs {
  type: 'personalData' | 'parkingRules'
  linkProcessingPersonalData?: string | null
  linkParkingRules?: string | null
}

export function getConsentCheckboxTitle({
  type,
  linkProcessingPersonalData,
  linkParkingRules,
}: GetConsentCheckboxTitleArgs) {
  if (type === 'personalData') {
    return linkProcessingPersonalData
      ? `<span>Я даю согласие на <a href=${linkProcessingPersonalData} target='_blank'>обработку персональных данных</a></span>`
      : `<span>Субъект дает согласие на обработку персональных данных (общее описание способов обработки данных приведено в Федеральном законе от 27.07.2006 152-ФЗ «О&nbsp;персональных данных»)</span>`
  }

  if (type === 'parkingRules') {
    return linkParkingRules
      ? `<span>Я ознакомлен(а) с <a href=${linkParkingRules} target='_blank'>правилами пользования парковкой</a></span>`
      : `<span>Я ознакомлен(а) с правилами пользования парковкой</span>`
  }
}
